require('jquery-watch');

export const helper = {
  setBackdropBg(el) {
    $('.js-fp-backdrop').css('background-image', `url(${$(el).data('bg')})`);
  },
  setLongBackdropBg(el) {
    $('.js-fp-backdrop .js-long-left-image-video').css('background-image', `url(${$(el).data('bg')})`);
  },
  videoController(action, videoEl) {
    let videoBg = document.getElementById(videoEl.attr('id'));

    if(!videoBg) return;

    switch (action) {
      case 'play':
        $(videoEl).removeClass('d-none');
        videoBg.play();
        break;

      case 'stop':
        $(videoEl).addClass('d-none');
        videoBg.currentTime = 0;
        videoBg.pause();
        break;

      default:
        break;
    }
  },
  appendFooter() {
    $('.js-append-footer').append($('footer'));

    // if ($(window).innerWidth() >= 979.89) {
    // $('.js-fp-wrapper').find('footer').addClass('section fp-auto-height');
    // } else {
    //   $('.js-fp-wrapper').find('footer').removeClass('section fp-auto-height');
    // }

    helper.observer();
  },
  removeClasser() {
    $('.js-remove-class-section > section').removeClass("section");
  },
  appendBottle() {
    if ($(window).innerWidth() <= 1024 || $('#sustainability').hasClass('is-mobile')) {
      // if($('#sustainability').hasClass('is-mobile')) {

      // }

      let eleBttle = document.getElementById('js-bottles').cloneNode(true);
        if(!eleBttle) return;

        document.getElementsByClassName('js-mobile-append')[0].insertBefore(eleBttle, document.getElementsByClassName('js-mobile-append')[0].childNodes[0]);
    }
  },
  hasScrollable() {
    if ($(window).innerWidth() <= 1024 || $('#sustainability').hasClass('is-mobile')) {
      // console.log();
      if(document.getElementsByClassName('js-append-footer')[0].querySelectorAll('.fp-scrollable').length <= 0) {
        document.getElementById('js-static-image').style.display = "none";
        document.getElementsByClassName('js-append-footer')[0].classList.add('without-scrollable');
      }
    }
  },
  observer(e) {
    // console.log(e);
    let currSlide;
    if(typeof e != 'undefined') {
      currSlide = e;
    }
    setTimeout(() => {
      $('.js-append-footer .fp-scroller').watch({
        // specify CSS styles or attribute names to monitor
        properties: "transform",

        // callback function when a change is detected
        callback: function (data, i) {
          let self, styleString;
          self = $(this);
          styleString = self.attr('style');

          if (styleString.includes('translate(0px, 0px)')) {
            // fullpage_api.moveSectionUp();
            window.requestAnimationFrame(function () { fullpage_api.moveTo(currSlide) });
          }
        }
      });
    }, 500);
  },
  scrollIconCtrl(origin, destination, direction) {
    destination.index <= 1 ? $('.js-btn-scroll').removeClass('fade') : $('.js-btn-scroll').addClass('fade');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featured/lib/helper.js